import { render, staticRenderFns } from "./marksRecord.vue?vue&type=template&id=1d38aa3c&scoped=true&"
import script from "./marksRecord.vue?vue&type=script&lang=js&"
export * from "./marksRecord.vue?vue&type=script&lang=js&"
import style0 from "./marksRecord.vue?vue&type=style&index=0&id=1d38aa3c&lang=scss&scoped=true&"
import style1 from "./marksRecord.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d38aa3c",
  null
  
)

export default component.exports